import { render, staticRenderFns } from "./bi-person-item.vue?vue&type=template&id=1a999846&"
import script from "./bi-person-item.vue?vue&type=script&lang=ts&"
export * from "./bi-person-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports